var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit"},[_c('div',{staticClass:"field"},[_c('button',{staticClass:"button is-success",attrs:{"disabled":_vm.invalid},on:{"click":function($event){return _vm.submit()}}},[_vm._v(" Send ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }